export { default } from './client-error-page'
